import React, { Component } from 'react';

class SpotDetail extends Component {
  constructor(props: Props) {
    // Initialize the viewport to the one provided in props
    super(props)
    this.state = {
      hoge: 'hoge'
    }
  }

  render() {
    let {selectedSpot, changeSpotListState} = this.props
    if (selectedSpot) {
      return (
        <div className="SpotDetail">
          <div className="SpotDetail-header">
            <div className="SpotDetail-header-title">
              <input type="checkbox" id="sample_checkbox" checked={selectedSpot.visited} onChange={() => {changeSpotListState(selectedSpot)}}/>
              {selectedSpot.name}
            </div>
            <img src={selectedSpot.image} alt=''/>
          </div>
          <div className="SpotDetail-content">
            <div>{selectedSpot.description}</div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="SpotDetail">
          スポットを選択してください
        </div>
      )
    }

  }
}

export default SpotDetail;
